(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bond-tale-luxury-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('btl-luxury-header')) {
    customElements.define('btl-luxury-header', class extends HTMLElement {
      connectedCallback() {
        this.stopSearchPrompts();
        this.externalBottomOwner?.releaseHeader();
        this.controller?.abort();
        this.layoutObserver?.disconnect();
        cancelAnimationFrame(this.layoutFrame);
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = null;
        this.resetSticky();
        this.destroyBottomNav();
        this.controller = new AbortController();
        this.timers = new Map();
        this.activeRequest = null;
        this.setAttribute('data-enhanced', '');
        this.desktop = window.matchMedia('(min-width: 990px)');
        this.hover = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.navigation = this.querySelector('.btlh__desktop-nav');
        this.navList = this.querySelector('.btlh__nav-list');
        const on = (target, name, fn, options = {}) => target.addEventListener(name, fn, { ...options, signal: this.controller.signal });
        this.disclosures = [...this.querySelectorAll('[data-disclosure]')];
        this.disclosures.forEach(details => {
          const summary = details.querySelector(':scope > summary');
          summary.setAttribute('aria-expanded', String(details.open));
          on(details, 'toggle', () => {
            summary.setAttribute('aria-expanded', String(details.open));
            if (details.matches('[data-search]')) { this.toggleAttribute('data-search-open', details.open); this.syncSearch(); }
            if (details.open) {
              this.setStickyHidden(false);
              this.closePeers(details);
              this.fitDropdown(details);
              this.fitPanels();
              if (details.matches('[data-search]') && !this.desktop.matches) this.animateMobilePage('search');
            }
          });
          on(summary, 'click', event => {
            this.clearTimer(details);
            if (details.matches('[data-search]')) {
              event.preventDefault();
              if (details.open) this.close(details, true);
              else { this.open(details); this.syncSearch(); details.querySelector('input[type="search"]')?.focus({ preventScroll: true }); }
              return;
            }
            if (!details.open) this.closePeers(details);
          });
          on(summary, 'keydown', event => {
            if (event.key === 'ArrowDown' && details.matches('[data-desktop-menu], [data-search]')) {
              event.preventDefault();
              this.open(details);
              details.querySelector('a, input')?.focus();
            }
          });
          if (details.matches('[data-desktop-menu]')) {
            on(details, 'pointerenter', event => {
              if (this.canHover(event)) {
                this.clearTimer(details);
                this.timers.set(details, setTimeout(() => { this.timers.delete(details); this.open(details); }, 100));
              }
            });
            on(details, 'pointerleave', event => {
              if (!this.canHover(event)) return;
              this.clearTimer(details);
              this.timers.set(details, setTimeout(() => {
                this.timers.delete(details);
                if (!details.contains(document.activeElement)) this.close(details);
              }, 180));
            });
            on(details, 'focusout', event => {
              if (event.relatedTarget && !details.contains(event.relatedTarget) && !details.matches(':hover')) this.close(details);
            });
          }
        });
        this.setupMobile(on);
        this.setupInlineSearch(on);
        this.setupSearchPrompts(on);
        on(window, 'pageshow', event => {
          if (!event.persisted) return;
          this.syncSearch();
          const input = this.querySelector('[data-search][open] input[type="search"]');
          if (!input) return;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          if (!this.desktop.matches) input.focus({ preventScroll: true });
        });
        if (window.visualViewport) {
          on(window.visualViewport, 'resize', () => this.fitSearchViewport());
          on(window.visualViewport, 'scroll', () => this.fitSearchViewport());
        }
        this.setupBottomNav(on);
        on(this, 'keydown', event => {
          if (this.trapMobileFocus(event)) return;
          if (event.key !== 'Escape') return;
          const details = event.target.closest('details[open]');
          const target = details && this.contains(details) ? details : this.querySelector('[data-search][open], [data-mobile-menu][open], [data-desktop-menu][open]');
          if (target) { event.preventDefault(); event.stopPropagation(); this.close(target, true); }
        });
        on(this, 'click', event => {
          const closeButton = event.target.closest('[data-close-mobile], [data-close-search]');
          if (closeButton) this.close(closeButton.closest('details'), true);
        });
        on(document, 'pointerdown', event => { if (!this.contains(event.target)) this.closeAll(); });
        on(document, 'focusin', event => { if (!this.contains(event.target)) this.closeAll(); });
        on(this.desktop, 'change', () => { this.closeAll(); this.scheduleLayout(); });
        on(window, 'resize', () => { this.scheduleLayout(); this.fitPanels(); this.querySelectorAll('[data-desktop-menu][open]').forEach(details => this.fitDropdown(details)); });
        this.stickyWrapper = this.closest('.btl-luxury-header-section');
        this.stickyWrapper?.classList.toggle('btlh-sticky', ['always', 'scroll-up'].includes(this.dataset.sticky));
        this.lastScrollY = Math.max(0, window.scrollY);
        this.scrollDirection = 0;
        this.scrollTravel = 0;
        on(window, 'scroll', () => {
          if (this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => { this.scrollFrame = null; this.updateSticky(); });
        }, { passive: true });
        // Restoring focus after a touch or mouse click must not pin the header.
        this.keyboardNavigation = false;
        on(document, 'keydown', () => { this.keyboardNavigation = true; }, { capture: true });
        on(document, 'pointerdown', () => { this.keyboardNavigation = false; }, { capture: true, passive: true });
        on(this, 'focusin', () => { if (this.keyboardNavigation) this.setStickyHidden(false); });
        this.layoutObserver = new ResizeObserver(entries => {
          const width = entries[0].contentRect.width;
          if (width !== this.lastLayoutWidth) { this.lastLayoutWidth = width; this.scheduleLayout(); }
        });
        this.layoutObserver.observe(this.querySelector('.btlh__inner'));
        this.heightObserver = new ResizeObserver(() => { this.fitPanels(); this.updateSticky(); });
        this.heightObserver.observe(this);
        document.fonts?.ready.then(() => { if (this.isConnected) this.scheduleLayout(); });
        this.scheduleLayout();
        this.updateSticky();
        on(document, 'shopify:block:select', event => {
          if (!this.contains(event.target)) return;
          const target = [...this.querySelectorAll('[data-block-id]')].find(details => details.dataset.blockId === event.detail?.blockId);
          if (target) this.open(target);
        });
        on(document, 'shopify:block:deselect', event => { if (this.contains(event.target)) this.closeAll(); });
        on(document, 'shopify:section:deselect', event => { if (event.detail?.sectionId === this.dataset.sectionId || event.detail?.sectionId === this.externalBottomOwner?.dataset.sectionId) this.closeAll(); });
        this.syncNativeCartTarget();
        on(document, 'shopify:section:load', () => this.syncNativeCartTarget());
        { // Counts also belong to an independently rendered bottom navigation section.
          // Taste/Dawn's cart publication API is optional. No globals are overwritten.
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
              if (event?.cartData && Number.isInteger(event.cartData.item_count)) {
                this.activeRequest?.abort();
                const revision = this.cartRevision = (this.cartRevision || 0) + 1;
                this.shareCartSnapshot(event.cartData, revision);
              } else this.refreshCart(true);
            });
          }
          on(document, 'cart:updated', () => this.refreshCart());
          on(window, 'pageshow', () => this.refreshCart());
          on(window, 'focus', () => this.refreshCart());
          on(this, 'pointerenter', () => this.refreshCart());
          on(this, 'focusin', () => this.refreshCart());
        }
      }
      setupSearchCollections(on, search) {
        const defaults = search.querySelector('[data-search-defaults]');
        const input = search.querySelector('input[type="search"]');
        if (!defaults || !input) return;
        const list = defaults.querySelector('ul');
        const links = [...defaults.querySelectorAll('a')];
        const controls = input.getAttribute('aria-controls');
        const owns = input.getAttribute('aria-owns');
        const isCombobox = input.getAttribute('role') === 'combobox';
        let browseOpen = false;
        const select = link => {
          links.forEach(item => item.closest('li').setAttribute('aria-selected', String(item === link)));
          if (link) input.setAttribute('aria-activedescendant', link.closest('li').id);
          else input.removeAttribute('aria-activedescendant');
        };
        const setOpen = open => {
          const empty = !input.value.trim();
          browseOpen = !!open && empty;
          search.toggleAttribute('data-search-empty', empty);
          search.toggleAttribute('data-show-collections', browseOpen);
          defaults.hidden = !browseOpen;
          if (!browseOpen) select(null);
          if (!isCombobox) return;
          if (empty) input.setAttribute('aria-expanded', String(browseOpen));
          for (const [name, original] of [['aria-controls', controls], ['aria-owns', owns]]) {
            const value = browseOpen ? list.id : original;
            if (value) input.setAttribute(name, value);
            else input.removeAttribute(name);
          }
        };
        const sync = () => setOpen(!input.value.trim() && search.contains(document.activeElement));
        on(input, 'input', () => {
          if (!input.value.trim()) search.close?.();
          sync();
        });
        on(input, 'click', sync);
        on(search, 'reset', () => queueMicrotask(sync));
        on(search, 'focusin', () => {
          sync();
          select(links.includes(document.activeElement) ? document.activeElement : null);
        });
        on(search, 'focusout', event => {
          if (event.relatedTarget && !search.contains(event.relatedTarget)) setOpen(false);
        });
        on(document, 'pointerdown', event => {
          if (!search.contains(event.target)) setOpen(false);
        });
        on(search, 'keydown', event => {
          if (input.value.trim()) return;
          if (event.key === 'Escape' && browseOpen) {
            input.focus({ preventScroll: true });
            setOpen(false);
            if (this.desktop.matches) { event.preventDefault(); event.stopPropagation(); }
            return;
          }
          if (['ArrowDown', 'ArrowUp'].includes(event.key) && links.length) {
            event.preventDefault(); event.stopPropagation();
            setOpen(true);
            const current = links.indexOf(document.activeElement);
            const down = event.key === 'ArrowDown';
            const next = current < 0 ? (down ? 0 : links.length - 1) : (current + (down ? 1 : -1) + links.length) % links.length;
            links[next].focus({ preventScroll: true });
            links[next].scrollIntoView({ block: 'nearest' });
            select(links[next]);
          } else if (event.key === 'Enter' && event.target === input) event.preventDefault();
        }, { capture: true });
        on(search, 'keyup', event => {
          if (!input.value.trim() && browseOpen) event.stopPropagation();
        }, { capture: true });
        const observer = new MutationObserver(() => {
          if (browseOpen && !input.value.trim() && input.getAttribute('aria-expanded') !== 'true') input.setAttribute('aria-expanded', 'true');
        });
        if (isCombobox) observer.observe(input, { attributes: true, attributeFilter: ['aria-expanded'] });
        this.controller.signal.addEventListener('abort', () => observer.disconnect(), { once: true });
        on(window, 'pageshow', sync);
        setOpen(false);
      }
      stopSearchPrompts() {
        clearTimeout(this.searchPromptTimer);
        this.searchPromptTimer = null;
        this.restoreSearchPrompts?.();
        this.restoreSearchPrompts = null;
      }
      setupSearchPrompts(on) {
        this.stopSearchPrompts();
        const inputs = [...this.querySelectorAll('input[type="search"]')];
        const labels = [...this.querySelectorAll('.btlh__mobile-search-label')];
        const originalInputs = inputs.map(input => [input, input.getAttribute('placeholder') || '']);
        const originalLabels = labels.map(label => [label, label.textContent]);
        const restore = () => {
          originalInputs.forEach(([input, text]) => input.setAttribute('placeholder', text));
          originalLabels.forEach(([label, text]) => { label.textContent = text; });
        };
        this.restoreSearchPrompts = restore;
        let raw = '';
        try { raw = JSON.parse(this.dataset.searchPrompts || '""'); } catch { return; }
        if (this.dataset.animatedSearch !== 'true' || typeof raw !== 'string' || (!inputs.length && !labels.length)) return;
        const prompts = [...new Set(raw.slice(0, 12000).split(String.fromCharCode(10))
          .map(text => Array.from(text.trim()).slice(0, 100).join('')).filter(Boolean))].slice(0, 12);
        if (!prompts.length) return;
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const segmenter = typeof Intl.Segmenter === 'function' ? new Intl.Segmenter(undefined, { granularity: 'grapheme' }) : null;
        const phrases = prompts.map(text => segmenter ? [...segmenter.segment(text)].map(part => part.segment) : Array.from(text));
        let index = 0;
        let count = phrases[0].length;
        let erasing = true;
        const write = text => {
          labels.forEach(label => { label.textContent = text; });
          inputs.forEach(input => {
            if (!input.value && document.activeElement !== input) input.setAttribute('placeholder', text);
          });
        };
        const paused = () => !this.isConnected || document.hidden ||
          inputs.some(input => input.value || document.activeElement === input) ||
          !!this.querySelector('[data-mobile-menu][open], [data-search][open]');
        const schedule = delay => { this.searchPromptTimer = setTimeout(tick, delay); };
        const tick = () => {
          this.searchPromptTimer = null;
          if (paused() || motion.matches) { restore(); return; }
          const word = phrases[index];
          if (erasing) {
            count = Math.max(0, count - 1);
            write(word.slice(0, count).join(''));
            if (count === 0) { index = (index + 1) % phrases.length; erasing = false; schedule(250); }
            else schedule(40);
          } else {
            count = Math.min(word.length, count + 1);
            write(word.slice(0, count).join(''));
            if (count === word.length) { erasing = true; schedule(1800); }
            else schedule(75);
          }
        };
        const restart = () => {
          clearTimeout(this.searchPromptTimer);
          this.searchPromptTimer = null;
          index = 0;
          count = phrases[0].length;
          erasing = true;
          if (paused()) { restore(); return; }
          write(prompts[0]);
          if (!motion.matches && phrases.length > 1) schedule(1800);
        };
        inputs.forEach(input => {
          on(input, 'focus', restart);
          on(input, 'blur', restart);
          on(input, 'input', restart);
        });
        this.querySelectorAll('[data-mobile-menu], [data-search]').forEach(details => on(details, 'toggle', restart));
        on(document, 'visibilitychange', restart);
        on(motion, 'change', restart);
        restart();
      }
      setupInlineSearch(on) {
        const slot = this.querySelector('[data-inline-search]');
        const details = this.querySelector('[data-search]');
        const panel = details?.querySelector('.btlh__search-panel');
        const search = slot?.querySelector('.btlh__predictive') || panel?.querySelector('.btlh__predictive');
        if (!slot || !panel || !search) return;
        this.setupSearchCollections(on, search);
        const sync = () => {
          const destination = this.desktop.matches ? slot : panel;
          if (search.parentElement !== destination) {
            search.close?.();
            if (details.open) this.close(details);
            destination.append(search);
          }
        };
        on(this.desktop, 'change', sync);
        on(search, 'keydown', event => {
          if (this.desktop.matches && event.key === 'Escape') {
            search.close?.();
            event.stopPropagation();
          }
        });
        on(document, 'pointerdown', event => {
          if (this.desktop.matches && !slot.contains(event.target)) search.close?.();
        });
        on(search, 'focusin', () => {
          if (this.desktop.matches) this.closeAll();
        });
        sync();
      }
      setupMobile(on) {
        this.mobileMenu = this.querySelector('[data-mobile-menu]');
        this.mobilePanel = this.mobileMenu?.querySelector('.btlh__mobile-panel');
        this.mobileRoot = this.mobilePanel?.querySelector('[data-mobile-root="main"]');
        if (!this.mobileRoot) return;
        this.mobileToggle = this.mobileMenu.querySelector(':scope > summary');
        this.mobileRoots = [...this.mobilePanel.querySelectorAll('[data-mobile-root]')].map(view => {
          const marker = document.createComment('mobile navigation home');
          view.before(marker);
          return { view, marker, key: view.dataset.mobileRoot, title: view.dataset.menuTitle || 'Menu', hidden: view.hidden };
        });
        this.activeMobileRoot = 'main';
        this.mobilePage = document.createElement('div');
        this.mobilePage.className = 'btlh__mobile-page';
        this.mobileBar = document.createElement('div');
        this.mobileBar.className = 'btlh__mobile-backbar';
        this.mobileBack = document.createElement('button');
        this.mobileBack.type = 'button';
        this.mobileBack.className = 'btlh__mobile-back';
        this.mobileTitle = document.createElement('span');
        this.mobileTitle.className = 'btlh__mobile-current';
        this.mobileTitle.setAttribute('aria-live', 'polite');
        this.mobileBack.append(this.mobileTitle);
        this.mobileBar.append(this.mobileBack);
        this.mobilePage.append(this.mobileBar, this.mobileRoot);
        this.mobilePanel.insertBefore(this.mobilePage, this.mobilePanel.querySelector('.btlh__mobile-customer'));
        this.mobilePanel.setAttribute('data-drilldown', '');
        this.mobileRoot.classList.add('btlh__mobile-level');
        this.mobileStack = [{ view: this.mobileRoot, title: this.mobileRoot.dataset.menuTitle || 'Menu', scroll: 0 }];
        this.renderMobileLevel();
        this.syncMobileToggle();
        on(this.mobileBack, 'click', () => this.backMobile());
        on(this.mobilePanel, 'keydown', event => {
          if (event.key !== 'Tab' || !this.mobileMenu.open) return;
          const controls = [...this.mobilePanel.querySelectorAll('a[href], button:not([disabled]), summary, input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')]
            .filter(element => element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden');
          if (!controls.length) return;
          const current = controls.indexOf(document.activeElement);
          const next = event.shiftKey
            ? (current <= 0 ? controls.length - 1 : current - 1)
            : (current + 1) % controls.length;
          event.preventDefault();
          controls[next].focus();
        });
        on(this.mobilePanel, 'click', event => {
          const summary = event.target.closest('summary');
          if (summary?.parentElement.matches('.btlh__mobile-submenu')) {
            event.preventDefault();
            this.forwardMobile(summary.parentElement);
          } else if (event.target.closest('a[href]')) this.close(this.mobileMenu);
        });
        on(this.mobileToggle, 'click', () => {
          this.mobileOpener = this.mobileToggle;
          if (this.mobileMenu.open) this.resetMobile();
          else this.setMobileRoot('main');
        });
        on(this.mobileMenu, 'toggle', () => {
          this.syncMobileToggle();
          if (this.mobileMenu.open) {
            this.cancelMobileSearchMotion();
            this.lockMobileScroll();
            this.fitMobilePage();
            this.animateMobilePage('open');
            this.mobilePanel.querySelector('[data-close-mobile]')?.focus({ preventScroll: true });
          }
          else this.resetMobile();
        });
        if (window.visualViewport) {
          on(window.visualViewport, 'resize', () => this.fitMobilePage());
          on(window.visualViewport, 'scroll', () => this.fitMobilePage());
        }
        if (this.mobileMenu.open) this.lockMobileScroll();
      }
      attachBottomSection(owner) {
        if (this.externalBottomOwner === owner) return;
        this.externalBottomOwner?.releaseHeader();
        this.closeAll();
        this.legacyBottomNav = this.querySelector('[data-bottom-nav]');
        this.destroyBottomNav();
        if (this.legacyBottomNav) this.legacyBottomNav.hidden = true;
        this.externalBottomOwner = owner;
        owner.host = this;
        owner.syncCartTarget();
        owner.closeFallback();
        owner.restoreFallbackSpace();
        this.externalMobileRoots = [];
        if (this.mobilePanel && this.mobileRoots) owner.menuRoots.forEach(root => {
          const entry = { view: root.view, marker: root.marker, key: root.view.dataset.mobileRoot, title: root.view.dataset.menuTitle || 'Menu', hidden: true, external: true };
          root.view.hidden = true;
          root.view.querySelectorAll('[data-bottom-parent-prefix]').forEach(label => { label.textContent = this.dataset.viewLabel || 'Explore'; });
          const parentRules = new Map([...this.querySelectorAll('[data-bottom-parent-rule]')].map(rule => [rule.dataset.bottomParentRule, rule.dataset.showParent]));
          root.view.querySelectorAll(':scope > li[data-bottom-menu-item]').forEach(item => {
            const parent = item.querySelector(':scope > details > .btlh__mobile-children > .btlh__parent-link');
            if (parent) parent.hidden = parentRules.get(item.dataset.bottomMenuItem) === 'false';
          });
          this.mobilePanel.append(root.view);
          this.mobileRoots.push(entry);
          this.externalMobileRoots.push(entry);
        });
        if (owner.nav) {
          owner.nav.querySelectorAll('[data-bottom-menu]').forEach(button => { button.setAttribute('aria-controls', this.mobileMenu?.id || owner.dialog.id); });
          this.append(owner.nav);
        }
        this.dataset.bottomEnabled = String(!!owner.nav);
        this.setupBottomNav();
        owner.syncAnnouncements();
        this.syncNativeCartTarget();
        this.refreshCart();
      }
      detachBottomSection(owner) {
        if (this.externalBottomOwner !== owner) return;
        this.closeAll();
        this.setMobileRoot('main');
        this.destroyBottomNav();
        this.externalMobileRoots?.forEach(entry => {
          entry.marker.before(entry.view);
          entry.view.hidden = true;
          entry.view.classList.remove('btlh__mobile-level');
        });
        if (this.mobileRoots) this.mobileRoots = this.mobileRoots.filter(entry => !entry.external);
        this.externalMobileRoots = null;
        if (owner.nav) {
          owner.navMarker.before(owner.nav);
          owner.nav.querySelectorAll('[data-bottom-menu]').forEach(button => { button.setAttribute('aria-controls', owner.dialog.id); button.setAttribute('aria-expanded', 'false'); });
        }
        owner.host = null;
        this.externalBottomOwner = null;
        if (this.legacyBottomNav) this.legacyBottomNav.hidden = false;
        this.legacyBottomNav = null;
        this.dataset.bottomEnabled = String(!!this.querySelector('[data-bottom-nav]'));
        if (this.isConnected && this.controller && !this.controller.signal.aborted) this.setupBottomNav();
        this.syncNativeCartTarget();
      }

      setupBottomNav() {
        this.bottomController?.abort();
        this.bottomController = new AbortController();
        const on = (target, name, fn, options = {}) => target.addEventListener(name, fn, { ...options, signal: this.bottomController.signal });
        this.bottomNav = this.querySelector('[data-bottom-nav]:not([hidden])');
        if (!this.bottomNav) return;
        this.bottomMenus = [...this.bottomNav.querySelectorAll('[data-bottom-menu]')];
        if (this.mobileMenu) this.bottomMenus.forEach(button => {
          on(button, 'click', event => {
            event.preventDefault();
            const key = button.dataset.bottomMenu;
            const wasOpen = this.mobileMenu.open && this.activeMobileRoot === key;
            this.mobileOpener = button;
            this.resetMobile();
            if (wasOpen) this.close(this.mobileMenu, true);
            else {
              if (!this.setMobileRoot(key)) return;
              this.open(this.mobileMenu);
              this.lockMobileScroll();
              this.syncMobileToggle();
              this.mobileRoot.querySelector('summary, a[href]')?.focus({ preventScroll: true });
            }
          });
        });
        // Reserve real document space, including the device inset, so the footer remains reachable.
        this.bottomBodyPadding = { value: document.body.style.getPropertyValue('padding-bottom'), priority: document.body.style.getPropertyPriority('padding-bottom') };
        this.bottomBasePadding = parseFloat(getComputedStyle(document.body).paddingBottom) || 0;
        this.bottomNavObserver = new ResizeObserver(() => this.updateBottomNavSpace());
        this.bottomNavObserver.observe(this.bottomNav);
        on(this.desktop, 'change', () => this.updateBottomNavSpace());
        this.updateBottomNavSpace();
        this.syncMobileToggle();
      }
      updateBottomNavSpace() {
        if (!this.bottomNav || !this.isConnected) return;
        this.bottomNavHeight = this.desktop.matches ? 0 : this.bottomNav.getBoundingClientRect().height;
        if (this.bottomNavHeight) document.body.style.setProperty('padding-bottom', `${this.bottomBasePadding + this.bottomNavHeight}px`);
        else this.restoreBottomPadding();
        const hidden = this.hasAttribute('data-sticky-hidden');
        this.inert = hidden && !this.bottomNavHeight;
        this.querySelector('.btlh__inner').inert = hidden && !!this.bottomNavHeight;
        this.fitMobilePage();
      }
      restoreBottomPadding() {
        if (!this.bottomBodyPadding) return;
        const saved = this.bottomBodyPadding;
        if (saved.value) document.body.style.setProperty('padding-bottom', saved.value, saved.priority);
        else document.body.style.removeProperty('padding-bottom');
      }
      destroyBottomNav() {
        this.bottomController?.abort();
        this.bottomController = null;
        this.bottomNavObserver?.disconnect();
        this.restoreBottomPadding();
        this.bottomBodyPadding = null;
        this.bottomNavHeight = 0;
        this.bottomNav = null;
        this.bottomMenus = null;
        this.removeAttribute('data-search-open');
        const inner = this.querySelector('.btlh__inner');
        if (inner) inner.inert = false;
      }
      syncMobileToggle() {
        if (!this.mobileToggle) return;
        this.mobileToggle.setAttribute('aria-label', this.mobileMenu.open ? this.mobileToggle.dataset.closeLabel || 'Close' : this.mobileToggle.dataset.openLabel || 'Menu');
        this.mobileToggle.setAttribute('aria-expanded', String(this.mobileMenu.open));
        this.bottomMenus?.forEach(button => button.setAttribute('aria-expanded', String(this.mobileMenu.open && button.dataset.bottomMenu === this.activeMobileRoot)));
      }
      setMobileRoot(key) {
        const root = this.mobileRoots?.find(root => root.key === key);
        if (!root) return false;
        this.resetMobile();
        if (root.view !== this.mobileRoot) {
          const previous = this.mobileRoots.find(root => root.view === this.mobileRoot);
          previous.marker.before(previous.view);
          previous.view.hidden = true;
          previous.view.classList.remove('btlh__mobile-level');
          this.mobileRoot = root.view;
          this.mobileRoot.hidden = false;
          this.mobileRoot.classList.add('btlh__mobile-level');
          this.mobilePage.append(this.mobileRoot);
        }
        this.activeMobileRoot = key;
        this.mobileStack = [{ view: this.mobileRoot, title: root.title, scroll: 0 }];
        this.mobilePanel.setAttribute('aria-label', root.title);
        this.renderMobileLevel();
        this.syncMobileToggle();
        return true;
      }
      renderMobileLevel() {
        const current = this.mobileStack.at(-1);
        this.mobileBar.hidden = this.mobileStack.length === 1;
        this.mobileTitle.textContent = this.mobileStack.length > 1 ? current.title : '';
        this.mobileBack.setAttribute('aria-label', `${current.title}, back to ${this.mobileStack.length > 1 ? this.mobileStack.at(-2).title : current.title}`);
        this.mobilePage.scrollTop = current.scroll || 0;
      }
      forwardMobile(details) {
        const view = details.querySelector(':scope > .btlh__mobile-children, :scope > ul');
        if (!view || this.mobileStack.some(level => level.view === view)) return;
        const summary = details.querySelector(':scope > summary');
        const current = this.mobileStack.at(-1);
        current.scroll = this.mobilePage.scrollTop;
        current.view.hidden = true;
        const marker = document.createComment('mobile level home');
        view.before(marker);
        view.classList.add('btlh__mobile-level');
        view.hidden = false;
        this.mobilePage.append(view);
        summary.setAttribute('aria-expanded', 'true');
        this.mobileStack.push({ view, marker, trigger: summary, title: summary.textContent.trim(), scroll: 0 });
        this.renderMobileLevel();
        this.animateMobilePage('forward');
        (view.querySelector('summary, a[href], button') || this.mobileBack).focus({ preventScroll: true });
      }
      restoreMobileLevel(level) {
        level.marker.before(level.view);
        level.marker.remove();
        level.view.hidden = false;
        level.view.classList.remove('btlh__mobile-level');
        level.trigger.setAttribute('aria-expanded', 'false');
      }
      backMobile() {
        if (this.mobileStack.length < 2) return;
        const previous = this.mobileStack.pop();
        this.restoreMobileLevel(previous);
        this.mobileStack.at(-1).view.hidden = false;
        this.renderMobileLevel();
        this.animateMobilePage('back');
        previous.trigger.focus({ preventScroll: true });
      }
      animateMobilePage(direction) {
        this.mobileAnimation?.cancel();
        const search = direction === 'search';
        const opening = search || direction === 'open';
        const target = search ? this.querySelector('.btlh__search-panel') : opening ? this.mobilePanel : this.mobilePage;
        if (!target?.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const from = opening || direction === 'back' ? '-100%' : '100%';
        const frames = search
          ? [{ opacity: 0, transform: 'translateY(12px)' }, { opacity: 1, transform: 'translateY(0)' }]
          : [{ transform: `translateX(${from})` }, { transform: 'translateX(0)' }];
        this.mobileAnimation = target.animate(frames,
          { duration: opening ? 280 : 220, easing: 'cubic-bezier(.22,1,.36,1)' });
      }
      fitMobilePage() {
        if (!this.mobilePanel) return;
        const viewport = window.visualViewport;
        const top = this.mobileMenu?.open ? Math.max(0, viewport?.offsetTop || 0) : Math.max(0, this.getBoundingClientRect().bottom);
        const bottom = (viewport ? viewport.height + viewport.offsetTop : window.innerHeight) - (this.mobileMenu?.open ? 0 : (this.bottomNavHeight || 0));
        this.style.setProperty('--btlh-mobile-view-top', `${top}px`);
        this.style.setProperty('--btlh-mobile-view-height', `${Math.max(0, bottom - top)}px`);
      }
      lockMobileScroll() {
        if (this.mobileScrollLock) return;
        const root = document.documentElement;
        const body = document.body;
        const rect = this.getBoundingClientRect();
        const wrapper = this.closest('.btl-luxury-header-section');
        this.mobileScrollLock = { x: window.scrollX, y: window.scrollY, root: root.style.overflow, body: body.style.overflow, wrapper, minHeight: wrapper?.style.getPropertyValue('min-height'), minHeightPriority: wrapper?.style.getPropertyPriority('min-height') };
        // Pin the existing header before overflow locking changes Safari's sticky scroll container.
        wrapper?.style.setProperty('min-height', `${rect.height}px`);
        this.style.setProperty('--btlh-mobile-open-top', `${Math.max(0, rect.top)}px`);
        this.setAttribute('data-mobile-open', '');
        root.style.overflow = 'hidden';
        body.style.overflow = 'hidden';
      }
      unlockMobileScroll() {
        if (!this.mobileScrollLock) return;
        const saved = this.mobileScrollLock;
        this.mobileScrollLock = null;
        this.removeAttribute('data-mobile-open');
        this.style.removeProperty('--btlh-mobile-open-top');
        if (saved.minHeight) saved.wrapper?.style.setProperty('min-height', saved.minHeight, saved.minHeightPriority);
        else saved.wrapper?.style.removeProperty('min-height');
        document.documentElement.style.overflow = saved.root;
        document.body.style.overflow = saved.body;
        window.scrollTo({ left: saved.x, top: saved.y, behavior: 'instant' });
      }
      syncSearch() {
        const details = this.querySelector('[data-search]');
        const mobileOpen = !!details?.open && !this.desktop.matches;
        this.toggleAttribute('data-search-open', !!details?.open);
        details?.querySelector('.btlh__search-panel')?.toggleAttribute('aria-modal', mobileOpen);
        if (mobileOpen) {
          details.querySelector('.btlh__search-panel')?.setAttribute('aria-modal', 'true');
          this.lockMobileScroll();
          this.fitSearchViewport();
        } else if (!this.mobileMenu?.open) this.unlockMobileScroll();
      }
      fitSearchViewport() {
        if (!this.querySelector('[data-search][open]') || this.desktop.matches) return;
        const viewport = window.visualViewport;
        this.style.setProperty('--btlh-search-top', `${viewport?.offsetTop || 0}px`);
        this.style.setProperty('--btlh-search-height', `${viewport?.height || window.innerHeight}px`);
      }
      trapMobileFocus(event) {
        const searchPanel = !this.desktop.matches && this.querySelector('[data-search][open] .btlh__search-panel');
        if (event.key !== 'Tab' || (!searchPanel && !this.mobileMenu?.open)) return false;
        const scope = searchPanel || this;
        const targets = [...scope.querySelectorAll('a[href], button, summary, input')].filter(target => !target.disabled && (!searchPanel || target.tabIndex >= 0) && target.getClientRects().length && !target.closest('[hidden]'));
        if (searchPanel && targets.length) {
          const index = targets.indexOf(document.activeElement);
          const next = (index + (event.shiftKey ? -1 : 1) + targets.length) % targets.length;
          event.preventDefault(); targets[next].focus({ preventScroll: true }); return true;
        }
        const destination = event.shiftKey && document.activeElement === targets[0] ? targets.at(-1) : !event.shiftKey && document.activeElement === targets.at(-1) ? targets[0] : null;
        if (!destination) return false;
        event.preventDefault();
        destination.focus({ preventScroll: true });
        return true;
      }
      resetMobile() {
        if (!this.mobileStack) return;
        this.mobileAnimation?.cancel();
        while (this.mobileStack.length > 1) this.restoreMobileLevel(this.mobileStack.pop());
        this.mobileRoot.hidden = false;
        this.mobileStack[0].scroll = 0;
        this.mobileRoot.querySelectorAll('details[open]').forEach(details => this.close(details));
        this.renderMobileLevel();
        this.unlockMobileScroll();
      }
      destroyMobile() {
        if (!this.mobileStack) return;
        this.resetMobile();
        this.mobileRoots.forEach(root => {
          root.marker.before(root.view);
          root.marker.remove();
          root.view.hidden = root.hidden;
          root.view.classList.remove('btlh__mobile-level');
        });
        this.mobileRoots = null;
        this.mobilePanel.setAttribute('aria-label', 'Shop navigation');
        this.mobilePage.remove();
        this.mobilePanel.removeAttribute('data-drilldown');
        this.mobileMenu.open = false;
        this.syncMobileToggle();
        this.mobileStack = null;
      }
      scheduleLayout() { cancelAnimationFrame(this.layoutFrame); this.layoutFrame = requestAnimationFrame(() => this.fitNavigation()); }
      fitNavigation() {
        if (!this.isConnected || !this.navigation || !this.navList) return;
        const wasCompact = this.hasAttribute('data-compact');
        this.removeAttribute('data-compact');
        this.style.removeProperty('--btlh-fit-gap');
        if (this.dataset.headerLayout === 'classic') { this.fitPanels(); return; }
        if (!this.desktop.matches || !this.classList.contains('btlh--left')) { this.fitPanels(); return; }
        const items = [...this.navList.children];
        const linksWidth = items.reduce((total, item) => total + item.getBoundingClientRect().width, 0);
        const spaces = Math.max(0, items.length - 1);
        const available = this.navigation.clientWidth;
        const preferredGap = parseFloat(getComputedStyle(this).getPropertyValue('--btlh-nav-gap')) || 32;
        const gap = spaces ? Math.min(preferredGap, Math.max(10, (available - linksWidth - 2) / spaces)) : preferredGap;
        this.style.setProperty('--btlh-fit-gap', `${gap}px`);
        const compact = linksWidth + spaces * gap > available + 0.5;
        this.toggleAttribute('data-compact', compact);
        if (wasCompact !== compact) {
          const active = document.activeElement;
          const hiddenFocus = compact ? this.navigation.contains(active) : this.querySelector('[data-mobile-menu]')?.contains(active);
          this.closeAll();
          if (hiddenFocus) (compact ? this.querySelector('[data-mobile-menu] > summary') : this.navigation.querySelector('a, summary'))?.focus();
        }
        this.fitPanels();
        this.querySelectorAll('[data-desktop-menu][open]').forEach(details => this.fitDropdown(details));
      }
      canHover(event) { return this.dataset.hover === 'true' && this.desktop.matches && !this.hasAttribute('data-compact') && this.hover.matches && event.pointerType !== 'touch'; }
      clearTimer(details) { clearTimeout(this.timers?.get(details)); this.timers?.delete(details); }
      open(details) { this.clearTimer(details); this.setStickyHidden(false); this.closePeers(details); details.open = true; details.querySelector(':scope > summary').setAttribute('aria-expanded', 'true'); this.fitDropdown(details); this.fitPanels(); }
      fitDropdown(details) {
        if (!details.matches('[data-desktop-menu]') || !details.open) return;
        const panel = details.querySelector('.btlh__menu-panel');
        const columns = [...panel.querySelectorAll('.btlh__column')];
        const viewport = document.documentElement.clientWidth;
        const available = Math.max(0, viewport - 32);
        const padding = parseFloat(getComputedStyle(panel).paddingLeft) + parseFloat(getComputedStyle(panel).paddingRight) + 2;
        const gap = parseFloat(getComputedStyle(panel.querySelector('.btlh__columns')).columnGap) || 32;
        const content = panel.querySelector('.btlh__menu-content');
        const feature = panel.querySelector('.btlh__feature');
        const featureWidth = feature ? 200 + (parseFloat(getComputedStyle(content).columnGap) || 24) : 0;
        panel.style.removeProperty('--btlh-group-heading-height');
        let preferred = 128;
        columns.forEach(column => {
          column.style.width = 'max-content';
          column.style.maxWidth = '280px';
          preferred = Math.max(preferred, column.getBoundingClientRect().width);
          column.style.removeProperty('width');
          column.style.removeProperty('max-width');
        });
        const requested = Math.min(Number(panel.dataset.columns) || 1, columns.length);
        preferred = Math.ceil(preferred / 4) * 4;
        const count = Math.max(1, Math.min(requested, Math.floor((available - padding - featureWidth + gap) / (preferred + gap))));
        panel.style.setProperty('--btlh-visible-columns', count);
        const parent = panel.querySelector('.btlh__parent-link');
        const width = Math.min(available, Math.max(200, padding + featureWidth + Math.max(parent?.getBoundingClientRect().width || 0, count * preferred + (count - 1) * gap)));
        panel.style.width = `${width}px`;
        if (count > 1) {
          const headings = [...panel.querySelectorAll('.btlh__column--group > .btlh__group-heading, .btlh__column--group > .btlh__column-title')];
          const headingHeight = Math.max(44, ...headings.map(heading => heading.getBoundingClientRect().height));
          panel.style.setProperty('--btlh-group-heading-height', `${Math.ceil(headingHeight / 4) * 4}px`);
        }
        const trigger = details.querySelector(':scope > summary').getBoundingClientRect();
        const header = this.getBoundingClientRect();
        const label = details.querySelector('.btlh__nav-label')?.getBoundingClientRect() || trigger;
        panel.style.insetBlockStart = `${Math.round(Math.max(label.bottom + 8, trigger.bottom + 4) - header.top)}px`;
        const left = Math.max(16, Math.min(trigger.left + trigger.width / 2 - width / 2, viewport - 16 - width));
        panel.style.left = `${left - header.left}px`;
      }
      fitPanels() {
        const bottom = this.getBoundingClientRect().bottom;
        this.style.setProperty('--btlh-panel-height', `${Math.max(0, window.innerHeight - bottom - 12)}px`);
        this.style.setProperty('--btlh-search-backdrop-top', `${Math.max(0, bottom)}px`);
        this.fitMobilePage();
      }
      setStickyHidden(hidden) {
        if (hidden === this.hasAttribute('data-sticky-hidden')) return;
        if (hidden) this.closeAll();
        this.toggleAttribute('data-sticky-hidden', hidden);
        this.inert = hidden && !this.bottomNavHeight;
        this.querySelector('.btlh__inner').inert = hidden && !!this.bottomNavHeight;
      }
      cancelMobileSearchMotion() {
        this.mobileSearchAnimations?.forEach(animation => animation.cancel());
        this.mobileSearchAnimations = null;
      }
      releaseMobileSearchSpace() {
        const space = this.mobileSearchSpace;
        if (!space) return;
        if (space.value) space.style.setProperty('height', space.value, space.priority);
        else space.style.removeProperty('height');
        if (space.offsetValue) space.style.setProperty('--btlh-mobile-collapse-offset', space.offsetValue, space.offsetPriority);
        else space.style.removeProperty('--btlh-mobile-collapse-offset');
        if (!space.hadAttribute) space.wrapper.removeAttribute('data-btl-mobile-space');
        this.mobileSearchSpace = null;
      }
      syncMobileSearchSpace() {
        const wrapper = this.stickyWrapper;
        const enabled = !this.desktop.matches && this.dataset.mobileSearchHeader === 'true' &&
          this.dataset.mobileSubpage !== 'true' && wrapper && wrapper !== this;
        if (!enabled) {
          if (this.mobileSearchSpace) {
            this.cancelMobileSearchMotion();
            this.releaseMobileSearchSpace();
          }
          return;
        }
        const width = window.innerWidth;
        const resized = this.mobileSearchSpace && this.mobileSearchSpace.viewportWidth !== width;
        const measureOrigin = () => {
          const sticky = wrapper.classList.contains('btlh-sticky');
          if (sticky) wrapper.classList.remove('btlh-sticky');
          try { return Math.max(0, wrapper.getBoundingClientRect().top + window.scrollY); }
          finally { if (sticky) wrapper.classList.add('btlh-sticky'); }
        };
        if (resized) {
          this.cancelMobileSearchMotion();
          this.mobileSearchSpace.documentTop = measureOrigin();
          this.mobileSearchSpace.viewportWidth = width;
        }
        if (this.hasAttribute('data-mobile-search-compact') || this.mobileSearchAnimations) return;
        const height = this.getBoundingClientRect().height;
        const compactHeight = parseFloat(getComputedStyle(this).getPropertyValue('--btlh-mobile-compact-height')) || 60;
        if (!this.mobileSearchSpace) {
          const style = wrapper.style;
          this.mobileSearchSpace = { wrapper, style, value: style.getPropertyValue('height'),
            priority: style.getPropertyPriority('height'), hadAttribute: wrapper.hasAttribute('data-btl-mobile-space'),
            offsetValue: style.getPropertyValue('--btlh-mobile-collapse-offset'),
            offsetPriority: style.getPropertyPriority('--btlh-mobile-collapse-offset') };
        }
        const space = this.mobileSearchSpace;
        space.collapseAt = Math.max(0, height - compactHeight);
        space.style.setProperty('height', height + 'px');
        space.style.setProperty('--btlh-mobile-collapse-offset', space.collapseAt + 'px');
        wrapper.setAttribute('data-btl-mobile-space', '');
        const wrapperTop = wrapper.getBoundingClientRect().top;
        if (wrapperTop > -space.collapseAt + 0.5) space.documentTop = Math.max(0, wrapperTop + window.scrollY);
        else if (space.documentTop == null) space.documentTop = measureOrigin();
        space.viewportWidth = width;
      }
      setMobileSearchCompact(compact) {
        const summary = this.querySelector('[data-search] > summary');
        const animate = !this.desktop.matches && typeof this.animate === 'function' &&
          !window.matchMedia('(prefers-reduced-motion: reduce)').matches &&
          !this.querySelector('[data-mobile-menu][open], [data-search][open]');
        const moving = [summary, this.querySelector('[data-mobile-menu] > summary'), this.querySelector('.btlh__cart')]
          .filter(Boolean).map(element => ({ element, rect: element.getBoundingClientRect() }));
        this.cancelMobileSearchMotion();
        this.toggleAttribute('data-mobile-search-compact', compact);
        this.scheduleLayout();
        if (!animate || !summary) return;

        const timing = { duration: 220, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'both' };
        const motions = [];
        moving.forEach(({ element, rect }) => {
          const after = element.getBoundingClientRect();
          const from = { transform: 'translate(' + (rect.left - after.left) + 'px, ' + (rect.top - after.top) + 'px)' };
          const to = { transform: 'translate(0, 0)' };
          if (element === summary) {
            Object.assign(from, { width: rect.width + 'px', height: rect.height + 'px' });
            Object.assign(to, { width: after.width + 'px', height: after.height + 'px' });
          }
          motions.push(element.animate([from, to], timing));
        });
        this.mobileSearchAnimations = motions;
        Promise.all(motions.map(animation => animation.finished.catch(() => {}))).then(() => {
          if (this.mobileSearchAnimations !== motions) return;
          this.cancelMobileSearchMotion();
          if (this.isConnected) this.scheduleLayout();
        });
      }

      updateSticky() {
        if (!this.isConnected || !this.stickyWrapper) return;
        this.syncMobileSearchSpace();
        const mobileSearchHeader = !this.desktop.matches && this.dataset.mobileSearchHeader === 'true';
        const maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        const y = Math.min(maxScroll, Math.max(0, window.scrollY));
        const previousY = Math.min(maxScroll, Math.max(0, this.lastScrollY ?? y));
        const delta = y - previousY;
        this.lastScrollY = y;
        const mobileListing = !this.desktop.matches && !!document.querySelector("btl-mobile-facets");
        const wasCompact = this.hasAttribute('data-mobile-search-compact');
        const collapseAt = this.mobileSearchSpace?.collapseAt ?? 96;
        const pinnedAt = (this.mobileSearchSpace?.documentTop ?? 0) + collapseAt;
        const compact = mobileSearchHeader && (this.dataset.mobileSubpage === 'true' || y > pinnedAt + (wasCompact ? 0 : 12));
        if (compact !== wasCompact) this.setMobileSearchCompact(compact);
        const enabled = ['always', 'scroll-up'].includes(this.dataset.sticky) || mobileListing || mobileSearchHeader;
        this.stickyWrapper.classList.toggle('btlh-sticky', enabled);
        const stuck = enabled && y > 0 && this.stickyWrapper.getBoundingClientRect().top <= 0.5;
        this.toggleAttribute('data-stuck', stuck);
        const keyboardFocus = this.keyboardNavigation && this.contains(document.activeElement);
        const pinned = keyboardFocus || !!this.querySelector('[data-desktop-menu][open], [data-mobile-menu][open], [data-search][open]');
        if (!stuck || mobileSearchHeader || !(this.dataset.sticky === 'scroll-up' || mobileListing) || pinned) {
          this.setStickyHidden(false);
          this.scrollDirection = 0;
          this.scrollTravel = 0;
        } else if (Math.abs(delta) >= 1) {
          const direction = Math.sign(delta);
          this.scrollTravel = direction === this.scrollDirection ? this.scrollTravel + Math.abs(delta) : Math.abs(delta);
          this.scrollDirection = direction;
          if (this.scrollTravel >= (direction > 0 ? 12 : 24)) this.setStickyHidden(direction > 0);
        }
        if (!this.hasAttribute('data-sticky-hidden')) this.fitPanels();
      }
      resetSticky() {
        this.destroyMobile();
        this.heightObserver?.disconnect();
        this.stickyWrapper?.classList.remove('btlh-sticky');
        this.removeAttribute('data-stuck');
        this.removeAttribute('data-sticky-hidden');
        this.inert = false;
      }
      close(details, focus = false) {
        if (!details) return;
        if (details === this.mobileMenu) this.resetMobile();
        this.clearTimer(details);
        details.open = false;
        const summary = details.querySelector(':scope > summary');
        summary.setAttribute('aria-expanded', 'false');
        details.querySelectorAll('details[open]').forEach(child => this.close(child));
        if (details === this.mobileMenu) this.syncMobileToggle();
        if (details.matches('[data-search]')) this.removeAttribute('data-search-open');
        if (focus) (details === this.mobileMenu ? this.mobileOpener || summary : summary).focus({ preventScroll: true });
      }
      closePeers(current) {
        if (current.matches('[data-mobile-menu], [data-desktop-menu], [data-search]')) {
          this.querySelectorAll('[data-mobile-menu][open], [data-desktop-menu][open], [data-search][open]').forEach(details => { if (details !== current) this.close(details); });
        } else {
          current.parentElement.parentElement.querySelectorAll(':scope > li > details[open]').forEach(details => { if (details !== current) this.close(details); });
        }
      }
      closeAll() { this.disclosures?.forEach(details => this.close(details)); }
      syncNativeCartTarget() {
        // Taste updates this target before publishing cartUpdate, even when its original header is hidden.
        const nativeTarget = [...document.querySelectorAll('#cart-icon-bubble')].find(target => target !== this.nativeCartTarget);
        if (nativeTarget || !this.querySelector('[data-cart-count]')) {
          this.nativeCartTarget?.remove();
          this.nativeCartTarget = null;
          return;
        }
        if (this.nativeCartTarget?.isConnected) return;
        this.nativeCartTarget = document.createElement('span');
        this.nativeCartTarget.id = 'cart-icon-bubble';
        this.nativeCartTarget.hidden = true;
        this.nativeCartTarget.setAttribute('aria-hidden', 'true');
        this.append(this.nativeCartTarget);
      }
      setCount(count) {
        if (!this.isConnected || !Number.isInteger(count) || count < 0) return;
        this.querySelectorAll('[data-cart-count]').forEach(badge => {
          badge.textContent = count;
          badge.hidden = count === 0;
        });
        this.querySelectorAll('[data-cart-status]').forEach(status => {
          const text = `${status.dataset.cartLabel}: ${count}`;
          if (status.textContent !== text) status.textContent = text;
        });
      }
      shareCartSnapshot(cart, revision) {
        if (revision !== this.cartRevision) return;
        this.cartSnapshot = { cart, revision };
        this.setCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('btl:cart-snapshot', { detail: this.cartSnapshot }));
      }
      async refreshCart(force = false) {
        if (!this.isConnected || !this.querySelector('[data-cart-count]')) return;
        if (!force && (this.activeRequest || Date.now() - (this.lastCartRead || 0) < 1500)) return;
        this.activeRequest?.abort();
        this.lastCartRead = Date.now();
        const revision = this.cartRevision = (this.cartRevision || 0) + 1;
        const request = new AbortController();
        this.activeRequest = request;
        try {
          const response = await fetch(this.dataset.cartUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: request.signal });
          if (response.ok) this.shareCartSnapshot(await response.json(), revision);
        } catch (_) { /* Keep the last confirmed state and the normal cart link on network errors. */ }
        finally { if (this.activeRequest === request) this.activeRequest = null; }
      }
      disconnectedCallback() {
        this.stopSearchPrompts();
        this.cancelMobileSearchMotion();
        this.releaseMobileSearchSpace();
        this.externalBottomOwner?.releaseHeader();
        this.controller?.abort();
        this.layoutObserver?.disconnect();
        cancelAnimationFrame(this.layoutFrame);
        cancelAnimationFrame(this.scrollFrame);
        this.resetSticky();
        this.destroyBottomNav();
        this.nativeCartTarget?.remove();
        this.nativeCartTarget = null;
        this.activeRequest?.abort();
        this.activeRequest = null;
        this.unsubscribeCart?.();
        this.unsubscribeCart = null;
        this.timers?.forEach(timer => clearTimeout(timer));
        this.timers?.clear();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["btl-category-navigation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('btl-category-navigation')) {
    customElements.define('btl-category-navigation', class extends HTMLElement {
      connectedCallback() {
        this.lifecycle = new AbortController();
        const start = () => { if (this.isConnected && !this.controller) this.initialize(); };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', start, { once: true, signal: this.lifecycle.signal });
        } else {
          this.initializationFrame = requestAnimationFrame(start);
        }
      }
      initialize() {
        this.controller = new AbortController();
        this.viewport = this.querySelector('[data-category-viewport]');
        this.list = this.querySelector('.btlcat__list');
        this.previous = this.querySelector('[data-category-previous]');
        this.next = this.querySelector('[data-category-next]');
        if (!this.viewport || !this.list || !this.previous || !this.next) {
          this.controller.abort();
          this.controller = null;
          return;
        }
        const on = (target, name, handler) => target.addEventListener(name, handler, { signal: this.controller.signal });
        on(this.viewport, 'scroll', () => this.scheduleUpdate());
        on(this.previous, 'click', () => this.move(-1));
        on(this.next, 'click', () => this.move(1));
        on(this.viewport, 'keydown', event => {
          if (event.target !== this.viewport) return;
          const rtl = getComputedStyle(this.viewport).direction === 'rtl';
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.viewport.scrollBy({ left: (event.key === 'Home' ? -1 : 1) * (rtl ? -1 : 1) * this.viewport.scrollWidth, behavior: this.scrollBehavior() });
          }
        });
        on(document, 'shopify:block:select', event => {
          if (String(event.detail?.sectionId) !== this.dataset.sectionId) return;
          const item = [...this.list.children].find(child => child.dataset.categoryId === event.detail?.blockId);
          if (!item) return;
          const itemRect = item.getBoundingClientRect();
          const viewportRect = this.viewport.getBoundingClientRect();
          if (itemRect.left < viewportRect.left || itemRect.right > viewportRect.right) {
            this.viewport.scrollBy({ left: itemRect.left - viewportRect.left - (viewportRect.width - itemRect.width) / 2, behavior: 'auto' });
          }
        });
        this.resizeObserver = new ResizeObserver(() => this.scheduleUpdate());
        this.resizeObserver.observe(this.viewport);
        this.resizeObserver.observe(this.list);
        this.update();
      }
      scrollBehavior() {
        return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      }
      move(direction) {
        const rtl = getComputedStyle(this.viewport).direction === 'rtl';
        const item = this.list.firstElementChild;
        const step = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(this.list).columnGap || 0) : 100;
        const amount = Math.max(step, Math.floor(this.viewport.clientWidth / step) * step);
        this.viewport.scrollBy({ left: direction * (rtl ? -1 : 1) * amount, behavior: this.scrollBehavior() });
      }
      scheduleUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      }
      update() {
        const items = [...this.list.children];
        const overflowing = this.viewport.scrollWidth > this.viewport.clientWidth + 2;
        this.previous.hidden = this.next.hidden = !overflowing;
        if (!items.length) return;
        const viewport = this.viewport.getBoundingClientRect();
        const first = items[0].getBoundingClientRect();
        const last = items[items.length - 1].getBoundingClientRect();
        const rtl = getComputedStyle(this.viewport).direction === 'rtl';
        this.previous.disabled = !overflowing || (rtl ? first.right <= viewport.right + 5 : first.left >= viewport.left - 5);
        this.next.disabled = !overflowing || (rtl ? last.left >= viewport.left - 5 : last.right <= viewport.right + 5);
      }
      disconnectedCallback() {
        this.lifecycle?.abort();
        cancelAnimationFrame(this.initializationFrame);
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        this.frame = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["btl-mobile-bottom-navigation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('btl-mobile-bottom-navigation')) {
    customElements.define('btl-mobile-bottom-navigation', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const on = (target, name, fn, options = {}) => target.addEventListener(name, fn, { ...options, signal: this.controller.signal });
        this.nav = this.querySelector('[data-bottom-nav]');
        this.dialog = this.querySelector('dialog');
        this.navMarker = document.createComment('bottom navigation home');
        if (this.nav) this.nav.before(this.navMarker);
        else this.prepend(this.navMarker);
        this.menuRoots = [...this.querySelectorAll('[data-mobile-root]')].map(view => {
          const marker = document.createComment('bottom menu home');
          view.before(marker);
          return { view, marker };
        });
        this.desktop = window.matchMedia('(min-width: 990px)');
        this.navObserver = new ResizeObserver(() => this.updateFallbackSpace());
        if (this.nav) this.navObserver.observe(this.nav);
        on(this.desktop, 'change', () => { this.closeFallback(); this.updateFallbackSpace(); });
        if (this.nav) on(this.nav, 'click', event => {
          const button = event.target.closest('[data-bottom-menu]');
          if (!button || this.host?.mobileMenu) return;
          this.openFallback(button.dataset.bottomMenu, button);
        });
        on(this.dialog.querySelector('[data-bottom-fallback-close]'), 'click', () => this.closeFallback());
        on(this.dialog, 'cancel', event => { event.preventDefault(); this.closeFallback(); });
        on(this.dialog, 'click', event => { if (event.target.closest('a[href]')) this.closeFallback(); });
        on(document, 'shopify:section:load', () => this.scheduleHost());
        on(document, 'shopify:section:unload', () => this.scheduleHost());
        on(document, 'shopify:section:deselect', event => { if (event.detail?.sectionId === this.dataset.sectionId) this.closeFallback(); });
        this.hostObserver = new MutationObserver(() => this.scheduleHost());
        this.hostObserver.observe(document.body, { childList: true, subtree: true });
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
            if (this.host) return;
            if (Number.isInteger(event?.cartData?.item_count)) this.setCount(event.cartData.item_count);
            else this.refreshCart();
          });
        }
        on(document, 'cart:updated', () => this.refreshCart());
        on(window, 'pageshow', () => this.refreshCart());
        on(window, 'focus', () => this.refreshCart());
        if (this.nav) on(this.nav, 'focusin', () => this.refreshCart());
        this.scheduleHost();
      }
      scheduleHost() {
        if (this.hostFrame) return;
        this.hostFrame = requestAnimationFrame(() => {
          this.hostFrame = null;
          if (!this.isConnected) return;
          const host = [...document.querySelectorAll('btl-luxury-header')].find(header => header.isConnected && header.getClientRects().length && typeof header.attachBottomSection === 'function' && header.controller && !header.controller.signal.aborted);
          if (host !== this.host) {
            this.releaseHeader();
            if (host) host.attachBottomSection(this);
          }
          this.updateFallbackSpace();
          this.syncAnnouncements();
          this.syncCartTarget();
        });
      }
      releaseHeader() { this.host?.detachBottomSection(this); }
      syncAnnouncements() {
        if (!this.nav) return;
        const topStatus = this.host?.querySelector('.btlh__actions [data-cart-status]');
        const topVisible = topStatus && topStatus.closest('a')?.getClientRects().length;
        this.nav.querySelectorAll('[data-cart-status]').forEach((status, index) => {
          if (!topVisible && index === 0) { status.setAttribute('aria-live', 'polite'); status.setAttribute('aria-atomic', 'true'); }
          else { status.removeAttribute('aria-live'); status.removeAttribute('aria-atomic'); }
        });
      }
      updateFallbackSpace() {
        if (this.host || !this.nav || this.desktop.matches) { this.restoreFallbackSpace(); return; }
        if (!this.savedPadding) {
          this.savedPadding = { value: document.body.style.getPropertyValue('padding-bottom'), priority: document.body.style.getPropertyPriority('padding-bottom'), base: parseFloat(getComputedStyle(document.body).paddingBottom) || 0 };
        }
        document.body.style.setProperty('padding-bottom', `${this.savedPadding.base + this.nav.getBoundingClientRect().height}px`);
      }
      restoreFallbackSpace() {
        if (!this.savedPadding) return;
        if (this.savedPadding.value) document.body.style.setProperty('padding-bottom', this.savedPadding.value, this.savedPadding.priority);
        else document.body.style.removeProperty('padding-bottom');
        this.savedPadding = null;
      }
      openFallback(key, opener) {
        const view = key === 'main' ? this.dialog.querySelector('[data-bottom-fallback-main]') : this.menuRoots.find(root => root.view.dataset.mobileRoot === key)?.view;
        if (!view) return;
        this.dialog.querySelectorAll('[data-mobile-root], [data-bottom-fallback-main]').forEach(root => { root.hidden = root !== view; });
        this.fallbackOpener = opener;
        this.fallbackOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.dialog.showModal();
        opener.setAttribute('aria-expanded', 'true');
      }
      closeFallback() {
        if (!this.dialog?.open) return;
        this.dialog.close();
        document.body.style.overflow = this.fallbackOverflow || '';
        this.dialog.querySelectorAll('details[open]').forEach(details => { details.open = false; });
        this.fallbackOpener?.setAttribute('aria-expanded', 'false');
        this.fallbackOpener?.focus({ preventScroll: true });
        this.fallbackOpener = null;
      }
      setCount(count) {
        if (!Number.isInteger(count) || count < 0) return;
        this.nav?.querySelectorAll('[data-cart-count]').forEach(badge => { badge.textContent = count; badge.hidden = count === 0; });
        this.nav?.querySelectorAll('[data-cart-status]').forEach(status => { const text = `${status.dataset.cartLabel}: ${count}`; if (status.textContent !== text) status.textContent = text; });
      }
      syncCartTarget() {
        if (this.host || !this.nav?.querySelector('[data-cart-count]')) {
          this.nativeCartTarget?.remove();
          this.nativeCartTarget = null;
          return;
        }
        if (document.querySelector('#cart-icon-bubble') || this.nativeCartTarget?.isConnected) return;
        this.nativeCartTarget = document.createElement('span');
        this.nativeCartTarget.id = 'cart-icon-bubble';
        this.nativeCartTarget.hidden = true;
        this.nativeCartTarget.setAttribute('aria-hidden', 'true');
        this.append(this.nativeCartTarget);
      }
      async refreshCart() {
        if (this.host || !this.isConnected || !this.nav?.querySelector('[data-cart-count]') || this.activeRequest || Date.now() - (this.lastCartRead || 0) < 1500) return;
        this.lastCartRead = Date.now();
        const request = new AbortController();
        this.activeRequest = request;
        try {
          const response = await fetch(this.dataset.cartUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: request.signal });
          if (response.ok) this.setCount((await response.json()).item_count);
        } catch (_) { /* Native cart link and server-rendered count remain usable. */ }
        finally { if (this.activeRequest === request) this.activeRequest = null; }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.hostObserver?.disconnect();
        this.navObserver?.disconnect();
        cancelAnimationFrame(this.hostFrame);
        this.hostFrame = null;
        this.closeFallback();
        this.releaseHeader();
        this.restoreFallbackSpace();
        this.activeRequest?.abort();
        this.activeRequest = null;
        this.unsubscribeCart?.();
        this.unsubscribeCart = null;
        this.nativeCartTarget?.remove();
        this.nativeCartTarget = null;
        this.navMarker?.remove();
        this.menuRoots?.forEach(root => root.marker.remove());
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["btl-photobook-studio"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('btl-photo-studio')) customElements.define('btl-photo-studio', class extends HTMLElement {
  async connectedCallback() {
    if (this.ready) {
      if (this.closed) {
        this.closed=false;
        this.photos.forEach(p=>this.urls.set(p.id,URL.createObjectURL(p.file)));
        try { this.db=await this.openDB(); } catch(e) { this.storageFailed=true; }
        this.renderAll();
      }
      return;
    }
    this.ready=true;
    this.$=s=>this.querySelector(s); this.$$=s=>Array.from(this.querySelectorAll(s));
    this.dialog=this.$('dialog'); this.photos=[]; this.pages=[]; this.urls=new Map(); this.step=0; this.page=0; this.activeIndex=0; this.busy=false; this.closed=false;
    this.layouts=JSON.parse(this.$('[data-layouts]').textContent).filter(x=>[1,2,4].includes(x.slots));
    if (!this.layouts.length) this.layouts=[{id:'one',name:'One photo',slots:1,caption:true},{id:'two',name:'Two photos',slots:2,caption:true},{id:'four',name:'Four photos',slots:4,caption:true}];
    this.maxPages=Math.min(200,Math.max(1,Number(this.dataset.maxPages)||48));
    this.key='btl-photobook-v1:'+this.dataset.product;
    this.pages=Array.from({length:Math.min(this.maxPages,Math.max(1,Number(this.dataset.pages)||8))},()=>this.newPage());
    try {
      this.db=await this.openDB(); const draft=await this.readDraft();
      if(draft && [1,2].includes(draft.version) && Array.isArray(draft.photos) && Array.isArray(draft.pages) && draft.pages.length){
        for(const p of draft.photos){
          try {
            const bytes=p.bytes instanceof ArrayBuffer?p.bytes:await p.file.arrayBuffer();
            if(!bytes.byteLength)throw new Error('Empty photo');
            this.photos.push({id:p.id,name:p.name,width:p.width,height:p.height,file:new Blob([bytes],{type:p.type||p.file?.type||'image/jpeg'})});
          } catch(e){this.restoreIncomplete=true;}
        }
        this.pages=draft.pages.slice(0,this.maxPages).map(p=>this.normalisePage(p));this.page=Math.min(Number(draft.page)||0,this.pages.length-1);
      }
    } catch(e){this.storageFailed=true;}
    if(!this.isConnected) { this.db?.close(); this.closed=true; return; }
    this.photos.forEach(p=>this.urls.set(p.id,URL.createObjectURL(p.file)));
    this.layouts.forEach(l=>{const o=document.createElement('option');o.value=l.id;o.textContent=l.name;this.$('[data-layout]').append(o);});
    this.$('[data-start]').disabled=false;this.$('[data-start]').textContent=this.photos.length?'Continue your photo book':'Start creating';
    this.$('[data-draft-summary]').textContent=this.photos.length?`${this.photos.length} photos saved in this browser. Your draft is ready to continue.`:'Your photos stay on this device in this design preview.';
    this.$('[data-start]').addEventListener('click',()=>{this.renderAll();this.dialog.showModal();this.$('[data-step="0"]').focus();});
    this.$$('[data-add]').forEach(b=>b.addEventListener('click',()=>this.$('[data-files]').click()));
    this.$('[data-files]').addEventListener('change',async e=>{await this.addFiles(e.target.files);e.target.value='';});
    this.$$('[data-step]').forEach(b=>b.addEventListener('click',()=>this.goStep(Number(b.dataset.step))));
    this.$('[data-forward]').addEventListener('click',()=>this.step<2?this.goStep(this.step+1):this.dialog.close());
    this.$('[data-back]').addEventListener('click',()=>this.step?this.goStep(this.step-1):this.dialog.close());
    const drop=this.$('[data-drop]');['dragenter','dragover'].forEach(t=>drop.addEventListener(t,e=>{e.preventDefault();drop.dataset.drag='true';}));['dragleave','drop'].forEach(t=>drop.addEventListener(t,e=>{e.preventDefault();delete drop.dataset.drag;}));drop.addEventListener('drop',e=>this.addFiles(e.dataTransfer.files));
    this.$('[data-layout]').addEventListener('change',e=>{this.current().layout=e.target.value;this.activeIndex=0;this.changed();});
    this.$('[data-caption]').addEventListener('input',e=>{this.current().caption=e.target.value;this.queueSave();});
    ['fit','zoom','x','y'].forEach(k=>this.$(`[data-${k}]`).addEventListener('input',e=>{const s=this.activeSlot();if(!s)return;s[k]=k==='fit'?e.target.value:Number(e.target.value);this.renderSheet();this.queueSave();}));
    this.$('[data-clear]').addEventListener('click',()=>{this.current().slots[this.activeIndex]=null;this.changed();});
    this.$('[data-autofill]').addEventListener('click',()=>{const used=new Set(this.pages.flatMap(p=>p.slots.slice(0,this.layout(p).slots).filter(Boolean).map(s=>s.photo)));const remaining=this.photos.filter(p=>!used.has(p.id));let i=0;this.pages.forEach(p=>{for(let n=0;n<this.layout(p).slots;n++)if(!p.slots[n] && remaining[i])p.slots[n]=this.placement(remaining[i++].id);});this.changed();this.message(i?`${i} empty spaces filled. Existing photos were kept.`:'No empty spaces were filled. Add more photos or pages.');});
    this.$('[data-prev]').addEventListener('click',()=>this.selectPage(this.page-1));this.$('[data-next]').addEventListener('click',()=>this.selectPage(this.page+1));
    this.$('[data-add-page]').addEventListener('click',()=>{if(this.pages.length>=this.maxPages)return;this.pages.push(this.newPage());this.selectPage(this.pages.length-1);this.queueSave();});
    this.$('[data-remove-page]').addEventListener('click',()=>{if(this.pages.length<2)return;if((this.current().slots.some(Boolean)||this.current().caption)&&!window.confirm('Remove this page? Your original photos will stay in the photo library.'))return;this.pages.splice(this.page,1);this.page=Math.min(this.page,this.pages.length-1);this.activeIndex=0;this.changed();});
    this.$('[data-download]').addEventListener('click',()=>this.download());
    this.dialog.addEventListener('close',()=>{this.saveDraft();this.$('[data-start]').textContent=this.photos.length?'Continue your photo book':'Start creating';this.$('[data-start]').focus();});
    this.renderAll();if(this.restoreIncomplete)this.message('Some photos from an earlier draft could not be restored. Add them again from your device; your page layouts and captions were kept.');if(this.storageFailed)this.$('[data-save-status]').textContent='Browser storage unavailable · download your design to keep it';
  }
  disconnectedCallback(){queueMicrotask(()=>{if(this.isConnected)return;clearTimeout(this.saveTimer);this.urls?.forEach(u=>URL.revokeObjectURL(u));this.urls?.clear();this.db?.close();this.closed=true;});}
  newPage(){return {id:crypto.randomUUID(),layout:this.layouts[0].id,caption:'',slots:[null,null,null,null]};}
  normalisePage(p){const out=this.newPage();out.layout=this.layouts.some(l=>l.id===p.layout)?p.layout:out.layout;out.caption=String(p.caption||'').slice(0,300);out.slots=Array.from({length:4},(_,i)=>{const s=p.slots?.[i];if(!s||!this.photos.some(p=>p.id===s.photo))return null;return {photo:s.photo,fit:s.fit==='cover'?'cover':'contain',zoom:Math.min(3,Math.max(1,Number(s.zoom)||1)),x:Math.min(100,Math.max(0,Number(s.x)||0)),y:Math.min(100,Math.max(0,Number(s.y)||0))};});return out;}
  placement(id){return {photo:id,fit:'contain',zoom:1,x:50,y:50};}
  current(){return this.pages[this.page];} layout(p=this.current()){return this.layouts.find(l=>l.id===p.layout)||this.layouts[0];} activeSlot(){return this.current().slots[this.activeIndex];}
  openDB(){return new Promise((resolve,reject)=>{const r=indexedDB.open('btl-photo-studio',1);r.onupgradeneeded=()=>r.result.createObjectStore('drafts');r.onsuccess=()=>resolve(r.result);r.onerror=()=>reject(r.error);r.onblocked=()=>reject(new Error('Storage blocked'));});}
  readDraft(){return new Promise((resolve,reject)=>{const r=this.db.transaction('drafts').objectStore('drafts').get(this.key);r.onsuccess=()=>resolve(r.result);r.onerror=()=>reject(r.error);});}
  queueSave(){clearTimeout(this.saveTimer);this.$('[data-save-status]').textContent='Saving on this device…';this.saveTimer=setTimeout(()=>this.saveDraft(),600);}
  async saveDraft(){
    clearTimeout(this.saveTimer);
    if(!this.db){this.$('[data-save-status]').textContent='Not saved · download your design to keep it';return;}
    const sequence=this.saveSequence=(this.saveSequence||0)+1;
    const pages=structuredClone(this.pages),page=this.page;
    try{
      // Persist bytes instead of File references: Safari can invalidate stored file-backed blobs.
      const photos=await Promise.all(this.photos.map(async p=>({id:p.id,name:p.name,width:p.width,height:p.height,type:p.file.type,bytes:await p.file.arrayBuffer()})));
      if(sequence!==this.saveSequence)return;
      await new Promise((resolve,reject)=>{const tx=this.db.transaction('drafts','readwrite');tx.objectStore('drafts').put({version:2,photos,pages,page,updated:Date.now()},this.key);tx.oncomplete=resolve;tx.onerror=()=>reject(tx.error);tx.onabort=()=>reject(tx.error);});
      if(sequence!==this.saveSequence)return;
      this.$('[data-save-status]').textContent='Saved on this device';this.$('[data-draft-summary]').textContent=`${photos.length} photos · ${pages.length} pages saved in this browser`;
    }catch(e){this.$('[data-save-status]').textContent='Not saved · storage is full or unavailable';this.message('Your draft could not be saved in this browser. Keep this page open and download your design to keep a copy.');}
  }
  message(text){this.$('[data-message]').textContent=text;this.$('[data-message]').hidden=!text;}
  async addFiles(files){if(this.busy)return;this.busy=true;this.$$('[data-add]').forEach(b=>b.disabled=true);let rejected=0;let added=0;for(const file of Array.from(files||[])){if(!['image/jpeg','image/png','image/webp'].includes(file.type)||file.size>(Number(this.dataset.maxMb)||20)*1024*1024){rejected++;continue;}const u=URL.createObjectURL(file);try{const img=new Image();img.src=u;await img.decode();this.photos.push({id:crypto.randomUUID(),name:file.name,width:img.naturalWidth,height:img.naturalHeight,file});this.urls.set(this.photos[this.photos.length-1].id,u);added++;}catch(e){URL.revokeObjectURL(u);rejected++;}}this.busy=false;this.$$('[data-add]').forEach(b=>b.disabled=false);this.changed();this.message(rejected?`${added} photos added. ${rejected} files could not be added; use readable JPG, PNG or WebP files within the per-photo limit.`:added?`${added} photos added. Your original files are kept unchanged.`:'');}
  removePhoto(id){const used=this.pages.some(p=>p.slots.some(s=>s?.photo===id));if(used&&!window.confirm('Remove this photo from the library and every page using it?'))return;this.photos=this.photos.filter(p=>p.id!==id);this.pages.forEach(p=>p.slots=p.slots.map(s=>s?.photo===id?null:s));URL.revokeObjectURL(this.urls.get(id));this.urls.delete(id);this.changed();}
  goStep(n){if(n>0&&!this.photos.length){this.message('Choose at least one photo to start designing.');return;}this.step=Math.max(0,Math.min(2,n));this.message('');this.renderAll();this.$(`[data-step="${this.step}"]`).focus();}
  selectPage(n){this.page=Math.max(0,Math.min(this.pages.length-1,n));this.activeIndex=0;this.renderAll();this.queueSave();}
  changed(){this.renderAll();this.queueSave();}
  renderAll(){this.$$('[data-pane]').forEach(p=>p.hidden=Number(p.dataset.pane)!==this.step);this.$$('[data-step]').forEach(b=>{if(Number(b.dataset.step)===this.step)b.setAttribute('aria-current','step');else b.removeAttribute('aria-current');});this.$('[data-photo-count]').textContent=`${this.photos.length} photo${this.photos.length===1?'':'s'}`;this.$('[data-footer-summary]').textContent=`${this.photos.length} photos · ${this.pages.length} pages`;this.$('[data-forward]').textContent=['Arrange photos →','Review book →','Save & close'][this.step];this.$('[data-forward]').disabled=this.busy||(this.step===0&&!this.photos.length);this.$('[data-back]').textContent=this.step?'← Back':'Close';this.renderLibraries();this.renderSheet();this.renderPages();if(this.step===2)this.renderReview();}
  image(id,alt=''){const img=document.createElement('img');img.src=this.urls.get(id)||'';img.alt=alt;img.loading='lazy';return img;}
  renderLibraries(){const library=this.$('[data-library]');const mini=this.$('[data-mini-library]');library.replaceChildren();mini.replaceChildren();this.photos.forEach(p=>{const item=document.createElement('div');item.className='ps-library-item';item.append(this.image(p.id,p.name));const label=document.createElement('small');label.textContent=p.name;item.append(label);const remove=document.createElement('button');remove.type='button';remove.textContent='×';remove.setAttribute('aria-label',`Remove ${p.name}`);remove.addEventListener('click',()=>this.removePhoto(p.id));item.append(remove);library.append(item);const b=document.createElement('button');b.type='button';b.setAttribute('aria-label',`Place ${p.name} in photo space ${this.activeIndex+1}`);b.append(this.image(p.id,''));b.addEventListener('click',()=>{this.current().slots[this.activeIndex]=this.placement(p.id);this.changed();});mini.append(b);});}
  buildSheet(p,interactive){const sheet=document.createElement('div');sheet.className='ps-sheet';sheet.dataset.slots=this.layout(p).slots;for(let i=0;i<this.layout(p).slots;i++){const b=document.createElement(interactive?'button':'div');b.className='ps-slot';if(interactive){b.type='button';b.setAttribute('aria-label',`Photo space ${i+1}${p.slots[i]?', filled':', empty'}`);b.setAttribute('aria-pressed',String(this.activeIndex===i));b.addEventListener('click',()=>{this.activeIndex=i;this.renderSheet();this.renderLibraries();});}const s=p.slots[i];if(s&&this.urls.has(s.photo)){const img=this.image(s.photo,'');img.style.objectFit=s.fit;img.style.objectPosition=`${s.x}% ${s.y}%`;img.style.transform=`scale(${s.zoom})`;b.append(img);}else{const t=document.createElement('span');t.textContent=interactive?'＋ Choose a photo':'Empty space';b.append(t);}sheet.append(b);}return sheet;}
  renderSheet(){const replacement=this.buildSheet(this.current(),true);this.$('[data-sheet]').replaceChildren(...replacement.children);this.$('[data-sheet]').dataset.slots=replacement.dataset.slots;this.$('[data-page-label]').textContent=`Page ${this.page+1} of ${this.pages.length}`;this.$('[data-layout]').value=this.current().layout;this.$('[data-caption]').value=this.current().caption;this.$('.ps-caption-field').hidden=!this.layout().caption;this.$('[data-prev]').disabled=this.page===0;this.$('[data-next]').disabled=this.page===this.pages.length-1;this.$('[data-add-page]').disabled=this.pages.length>=this.maxPages;this.$('[data-remove-page]').disabled=this.pages.length<2;const s=this.activeSlot();['fit','zoom','x','y'].forEach(k=>{const input=this.$(`[data-${k}]`);input.disabled=!s;input.value=s?s[k]:({fit:'contain',zoom:1,x:50,y:50}[k]);});this.$('[data-clear]').disabled=!s;}
  renderPages(){const strip=this.$('[data-pages]');strip.replaceChildren();this.pages.forEach((p,i)=>{const b=document.createElement('button');b.type='button';b.textContent=`Page ${i+1}`;if(i===this.page)b.setAttribute('aria-current','page');b.addEventListener('click',()=>this.selectPage(i));strip.append(b);});}
  renderReview(){const grid=this.$('[data-review]');grid.replaceChildren();let empty=0;this.pages.forEach((p,i)=>{for(let n=0;n<this.layout(p).slots;n++)if(!p.slots[n])empty++;const b=document.createElement('button');b.type='button';b.className='ps-review-card';b.setAttribute('aria-label',`Edit page ${i+1}`);b.append(this.buildSheet(p,false));const t=document.createElement('strong');t.textContent=`Page ${i+1}`;b.append(t);if(this.layout(p).caption&&p.caption){const c=document.createElement('p');c.textContent=p.caption;b.append(c);}b.addEventListener('click',()=>{this.selectPage(i);this.goStep(1);});grid.append(b);});this.$('[data-review-count]').textContent=`${this.pages.length} pages`;this.$('[data-review-notice]').textContent=empty?`${empty} photo spaces are still empty. Return to Design to fill them, or remove unused pages.`:'Every photo space is filled. Review cropping and captions before keeping a copy.';}
  async download(){const button=this.$('[data-download]');button.disabled=true;button.textContent='Preparing your design…';try{const photos=[];for(const p of this.photos){const data=await new Promise((resolve,reject)=>{const r=new FileReader();r.onload=()=>resolve(r.result);r.onerror=reject;r.readAsDataURL(p.file);});photos.push({id:p.id,name:p.name,width:p.width,height:p.height,type:p.file.type,data});}const data={format:'bond-and-tale-photobook',version:1,product:this.dataset.product,layouts:this.layouts,pages:this.pages,photos,notice:'Design archive. Not a print-ready proof or an order. Archive importing is not available in this preview.'};const url=URL.createObjectURL(new Blob([JSON.stringify(data)],{type:'application/json'}));const a=document.createElement('a');a.href=url;a.download='bond-and-tale-photo-book.design.json';a.click();setTimeout(()=>URL.revokeObjectURL(url),60000);this.message('Your design file is ready. It contains your original photos; keep it private.');}catch(e){this.message('The design file could not be prepared. Your current browser draft is unchanged. Try saving fewer or smaller photos.');}finally{button.disabled=false;button.textContent='Download design file';}}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["btl-video-tiles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('btl-video-tiles')) {
    customElements.define('btl-video-tiles', class extends HTMLElement {
      connectedCallback() {
        this.lifecycle = new AbortController();
        const start = () => { if (this.isConnected && !this.controller) this.initialize(); };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true, signal: this.lifecycle.signal });
        else this.initializationFrame = requestAnimationFrame(start);
      }
      initialize() {
        this.controller = new AbortController();
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.states = new Map();
        const on = (target, name, handler) => target.addEventListener(name, handler, { signal: this.controller.signal });
        on(document, 'shopify:block:select', event => {
          if (String(event.detail?.sectionId) !== this.dataset.sectionId) return;
          const item = [...this.querySelectorAll('[data-video-block]')].find(tile => tile.dataset.videoBlock === event.detail?.blockId);
          const row = this.querySelector('.btlvid__tiles');
          if (!item || !row) return;
          const tileBounds = item.getBoundingClientRect();
          const rowBounds = row.getBoundingClientRect();
          if (tileBounds.left < rowBounds.left || tileBounds.right > rowBounds.right) {
            row.scrollBy({ left: tileBounds.left - rowBounds.left - (rowBounds.width - tileBounds.width) / 2, behavior: 'auto' });
          }
        });
        this.querySelectorAll('video').forEach(video => {
          const state = { visible: false, userPaused: false, resume: false, automatic: false, pausing: false, starting: false };
          this.states.set(video, state);
          video.controls = false;
          video.muted = true;
          on(video, 'play', () => {
            if (state.starting) state.starting = false;
            else { state.userPaused = false; state.automatic = false; }
            if (!state.visible || document.hidden) this.pause(video, state);
          });
          on(video, 'pause', () => {
            if (state.pausing) state.pausing = false;
            else { state.userPaused = true; state.resume = false; }
          });
        });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              const state = this.states.get(entry.target);
              state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.35;
              this.sync(entry.target, state);
            });
          }, { threshold: [0, 0.35] });
          this.states.forEach((state, video) => this.observer.observe(video));
        } else {
          this.states.forEach(state => { state.visible = true; });
        }
        on(document, 'visibilitychange', () => this.states.forEach((state, video) => this.sync(video, state)));
        on(this.motion, 'change', () => this.states.forEach((state, video) => {
          if (this.motion.matches && state.automatic) { state.resume = false; this.pause(video, state); }
          else this.sync(video, state);
        }));
      }
      pause(video, state) {
        if (!video.paused) { state.pausing = true; video.pause(); }
      }
      sync(video, state) {
        if (!state.visible || document.hidden) {
          if (!video.paused && !video.ended) state.resume = true;
          this.pause(video, state);
          return;
        }
        const automatic = this.dataset.autoplay === 'true' && !this.motion.matches && !state.userPaused;
        const resume = state.resume && (!state.automatic || !this.motion.matches);
        if (video.paused && (automatic || resume)) {
          state.resume = false;
          if (!resume) state.automatic = automatic;
          state.starting = true;
          video.muted = true;
          video.play().catch(() => { state.starting = false; });
        }
      }
      disconnectedCallback() {
        this.lifecycle?.abort();
        cancelAnimationFrame(this.initializationFrame);
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        this.states?.forEach((state, video) => video.pause());
        this.states?.clear();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slides-new"] && !Shopify.designMode) return;
  try {
    
  // Match the image area, including grid gutters and responsive image heights.
  if (!customElements.get('image-slideshow-controls')) {
    customElements.define('image-slideshow-controls', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => {
          this.host = this.closest('slideshow-component');
          this.slider = this.host?.querySelector('.slideshow');
          if (!this.slider) return;
          this.dotButtons = Array.from(this.querySelectorAll('.slider-counter__link'));
          this.dotRow = this.querySelector('.slideshow__control-wrapper');
          this.slides = Array.from(this.slider.querySelectorAll('.slideshow__slide'));
          this.activeDot = -1;
          this.dotButtons.forEach((button, index) => { button.style.left = index * 24 + (index > 0 ? 28 : 0) + 'px'; });
          this.sync = () => {
            const slide = this.slider.querySelector('.slideshow__slide[aria-hidden="false"]')
              || this.slider.querySelector('.slideshow__slide');
            const active = this.slides.indexOf(slide);
            if (active >= 0 && active !== this.activeDot && this.dotRow) {
              this.activeDot = active;
              const windowStart = Math.max(0, Math.min(active - 3, this.dotButtons.length - 6));
              this.dotRow.style.setProperty('--btl-dot-offset', -windowStart * 24 + 'px');
              const focused = document.activeElement;
              let focusClipped = false;
              this.dotButtons.forEach((button, index) => {
                const visible = index >= windowStart && index < windowStart + 6;
                button.style.left = index * 24 + (index > active ? 28 : 0) + 'px';
                button.style.setProperty('--btl-dot-scale', Math.max(.4, 1 - Math.max(0, Math.abs(index - active) - 1) * .2));
                button.inert = !visible;
                button.tabIndex = index === active ? 0 : -1;
                if (!visible && button === focused) focusClipped = true;
              });
              if (focusClipped) this.dotButtons[active]?.focus({ preventScroll: true });
              this.syncProgress();
            }
            const ratio = slide?.dataset.imageRatio;
            if (ratio && ratio !== this.activeImageRatio) {
              this.activeImageRatio = ratio;
              this.slider.style.setProperty('--mobile-slide-ratio', ratio);
            }
            const media = slide?.querySelector('.slideshow__media');
            if (!media) return;
            const hostRect = this.host.getBoundingClientRect();
            const sliderRect = this.slider.getBoundingClientRect();
            const mediaRect = media.getBoundingClientRect();
            this.style.setProperty('--controls-top', `${mediaRect.top - hostRect.top}px`);
            this.style.setProperty('--controls-left', `${sliderRect.left - hostRect.left}px`);
            this.style.setProperty('--controls-width', `${sliderRect.width}px`);
            this.style.setProperty('--controls-height', `${mediaRect.height}px`);
          };
          this.onSlideChange = () => {
            cancelAnimationFrame(this.frame);
            this.frame = requestAnimationFrame(this.sync);
          };
          this.observer = new ResizeObserver(this.sync);
          this.observer.observe(this.host);
          this.slider.querySelectorAll('.slideshow__media').forEach(media => this.observer.observe(media));
          this.onDotKey = event => {
            if (!this.dotRow?.contains(event.target) || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            event.stopPropagation();
            const next = Math.max(0, Math.min(event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.activeDot + (event.key === 'ArrowRight' ? 1 : -1), this.slides.length - 1));
            this.slider.scrollTo({ left: this.slides[next].offsetLeft - this.slides[0].offsetLeft, behavior: 'instant' });
            this.host.update();
            this.host.setSlideVisibility();
            this.sync();
            this.dotButtons[next]?.focus({ preventScroll: true });
          };
          this.onFocusIn = event => {
            if (this.host.autoplayButtonIsSetToPlay && event.target.matches(':focus-visible')) this.host.autoPlayToggle();
          };
          this.onManualNavigation = event => {
            const button = event.target.closest('button');
            if (!button || !this.host.autoplayButtonIsSetToPlay) return;
            if (button.matches('.slider-counter__link') || ['previous', 'next'].includes(button.name)) this.host.play();
          };
          this.addEventListener('click', this.onManualNavigation);
          this.addEventListener('keydown', this.onDotKey);
          this.host.addEventListener('focusin', this.onFocusIn);
          this.host.addEventListener('slideChanged', this.onSlideChange);
          this.progressMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.onProgressMotion = () => this.syncProgress();
          this.progressMotion.addEventListener('change', this.onProgressMotion);
          this.sync();
        });
      }
      syncProgress() {
        if (!this.host || !this.dotButtons) return;
        const dot = this.querySelector('.slider-counter__link--active .dot');
        const duration = Number(this.host.autoplaySpeed);
        if (this.progressMotion?.matches || !dot || !duration || this.progressDot !== dot) {
          const previousFill = this.progressDot?.querySelector('.btl-progress-fill');
          if (previousFill) previousFill.style.transform = getComputedStyle(previousFill).transform;
          this.progressAnimation?.cancel();
          this.progressDot?.removeAttribute('data-progress');
          this.progressAnimation = null;
          this.progressDot = dot;
        }
        if (this.progressMotion?.matches || !dot || !duration) return;
        if (!this.host.autoplayRunning) {
          this.progressAnimation?.pause();
          return;
        }
        if (this.progressAnimation && this.progressStart === this.host.autoplayStartedAt) return;
        this.progressAnimation?.cancel();
        let fill = dot.querySelector('.btl-progress-fill');
        if (!fill) {
          fill = document.createElement('span');
          fill.className = 'btl-progress-fill';
          fill.setAttribute('aria-hidden', 'true');
          dot.appendChild(fill);
        }
        if (!fill.animate) return;
        dot.setAttribute('data-progress', '');
        this.progressStart = this.host.autoplayStartedAt;
        this.progressAnimation = fill.animate(
          [{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }],
          { duration, easing: 'linear', fill: 'both' }
        );
        this.progressAnimation.currentTime = Math.min(duration, Math.max(0, performance.now() - this.progressStart));
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onManualNavigation);
        this.progressAnimation?.cancel();
        this.progressDot?.removeAttribute('data-progress');
        this.progressAnimation = null;
        this.progressDot = null;
        this.progressMotion?.removeEventListener('change', this.onProgressMotion);
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.removeEventListener('keydown', this.onDotKey);
        this.host?.removeEventListener('focusin', this.onFocusIn);
        this.host?.removeEventListener('slideChanged', this.onSlideChange);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
